<template>
  <div
    class="alertContainer"
    v-bind:style="{ height: height + 'px' }"
    v-bind:class="{ spacing: height !== 0, notDismissable: !dismissable }"
  >
    <div v-show="c" class="alert">
      <slot></slot>
    </div>
    <button v-show="dismissable && c" type="button" class="close" @click="dismiss()">
      <Icon icon="close" />
    </button>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'Alert-New',
  components: { Icon },
  data() {
    return {
      height: 0,
      c: false,
    };
  },
  props: {
    dismissable: { type: Boolean, default: true },
    type: { type: String },
    condition: { type: Boolean, default: true },
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        if (!this.c) {
          this.height = 0;
        } else {
          this.height = this.$el.scrollHeight;
        }
      });
    },
    dismiss() {
      this.c = false;
      this.height = 0;
    },
  },
  watch: {
    condition() {
      this.c = this.condition;
      this.calculateHeight();
    },
  },
  mounted() {
    window.el = this.$el;
    this.c = this.condition;
    this.calculateHeight();
  },
};
</script>

<style lang="scss" scoped>
.spacing {
  margin-bottom: $line-height-computed;
}

.alertContainer {
  position: relative;
  transition:
    height 0.5s,
    margin 0.5s;
  overflow: hidden;
  background: $alert-danger-bg;
}

.alert {
  padding: $sp;
  border: 0;
  margin: 0;
  margin-right: 3 * $sp;
  color: $alert-danger-text;
  :deep(p:last-child) {
    margin-bottom: 0;
  }
}
.alertContainer.notDismissable .alert {
  margin-right: 0;
}

.close {
  position: absolute;
  padding-right: $sp;
  right: 0;
  top: calc(50% - 7px);
  :deep(.fill) {
    fill: darken($alert-danger-bg, 60%) !important;
  }
}
.close,
.close:focus,
.close:active {
  box-shadow: none !important;
  background: transparent;
}
</style>
